import groupBy from "lodash/groupBy";
import { RpSweetAlert } from "@/components/alerts/RpSweetAlert";
import RpSvgIcon from "@/components/icons/RpSvgIcon";

type BulkSelectionInvalidMessage = Record<string, any>;
type FillFieldMessage = React.ReactNode;

export const rrdDisplaySelectLocationMsg = () => {
  RpSweetAlert.fire({
    html: (
      <p className="text-center fw-b text-dark fs-20">
        Hey! It looks like you haven't chosen your locations. Once you do you
        can apply your selections
      </p>
    ),
    confirmButtonText: "OK",
    showCancelButton: false,
    padding: "1rem",
  });
};

export const rrdDisplayFillAllFieldsMsg = (
  notValidMsg?: FillFieldMessage[]
) => {
  RpSweetAlert.fire({
    html: (
      <div>
        <p className="text-center fw-b text-dark fs-20">
          Please fill all fields with valid values
        </p>
        <div className="text-left mt-2">
          <ol>
            {notValidMsg?.map((msg, index) => (
              <li key={index} className="fw-b text-danger fs-12">
                {msg}
              </li>
            ))}
          </ol>
        </div>
      </div>
    ),
    confirmButtonText: "OK",
    showCancelButton: false,
    padding: "1rem",
  });
};

export const rrdDisplayBulkSelectionAppliedMsg = () => {
  return RpSweetAlert.fire({
    html: (
      <div className="text-center">
        <RpSvgIcon
          name="checked_circle"
          size="5rem"
          style={{
            color: "var(--status-success)",
          }}
        />
        <p className="text-center fw-b text-dark fs-20 mt-3">
          Selections Applied
        </p>
      </div>
    ),
    showConfirmButton: false,
    showCancelButton: false,
    padding: "1rem",
    timer: 2000,
  });
};

export const rrdDisplayBulkSelectionFailedMsg = (
  notValidMsg?: BulkSelectionInvalidMessage[]
) => {
  const locations = groupBy(notValidMsg, "location_name");
  RpSweetAlert.fire({
    width: "min(100vw, 800px)",
    html: (
      <div>
        <div className="text-center">
          <RpSvgIcon
            name="no_image"
            size="10rem"
            style={{
              color: "var(--primary-base)",
            }}
          />
        </div>
        <p className="text-center fw-b text-body fs-20 py-2">
          Hey! Some of the coupons or hero images you selected are not available
          for some of the selected locations.
        </p>
        <div className="text-left mt-2 table-responsive">
          <table className="table" style={{ tableLayout: "fixed" }}>
            <thead style={{ backgroundColor: "transparent" }}>
              <tr>
                <th
                  style={{
                    color: "var(--neutral-700)",
                    fontWeight: "bold",
                    minWidth: 250,
                    border: 0,
                  }}
                >
                  Location
                </th>
                <th
                  style={{
                    color: "var(--neutral-700)",
                    fontWeight: "bold",
                    border: 0,
                    minWidth: 250,
                  }}
                >
                  Alert
                </th>
              </tr>
            </thead>
            <tbody>
              {Object.entries(locations)?.map(
                ([locationName, assets], index) => {
                  const assetsList = groupBy(assets, "type");
                  const heroImages = [
                    ...new Set(
                      assetsList?.["Hero Image"]?.map((a) => a.asset_name) || []
                    ),
                  ];
                  const coupons = [
                    ...new Set(
                      assetsList?.["Coupon"]?.map((a) => a.asset_name) || []
                    ),
                  ];
                  return (
                    <tr key={index} style={{ fontSize: ".7rem" }}>
                      <td style={{ fontWeight: "bold", minWidth: 250 }}>
                        {locationName}
                      </td>
                      <td
                        style={{
                          color: "var(--neutral-600)",
                          minWidth: 250,
                        }}
                      >
                        {heroImages?.length ? (
                          <div className="mb-1">
                            <strong>{heroImages?.join(", ")}</strong> hero
                            images not available
                          </div>
                        ) : null}
                        {coupons?.length ? (
                          <div>
                            <strong>{coupons?.join(", ")}</strong> coupons not
                            available
                          </div>
                        ) : null}
                      </td>
                    </tr>
                  );
                }
              )}
            </tbody>
          </table>
        </div>
      </div>
    ),
    confirmButtonText: "Confirm",
    showCancelButton: false,
    padding: "1rem",
  });
};
